import { GroupNodeLabel } from "@features/graph/graphViewModel"
import { GraphNodeData } from "@store/services/converter/types"

export const getNodeSelectOptions = (nodesData: GraphNodeData[]): GroupNodeLabel[] => {
  return nodesData.map((nodeData) => ({
    key: nodeData.node.name,
    label: nodeData.display.label,
    type: nodeData.node.type,
    group: "",
    sort: "",
  }))
}
